module.exports = __webpack_public_path__ + "assets/img/topicon (3).7703922d.svg";